import SectionMessage from '@atlaskit/section-message/message';

import SectionMessageAction from '@atlaskit/section-message/message-action';

import { useIntl } from 'react-intl';

import { messages } from './messages';

import { Stack } from '@atlaskit/primitives/compiled/stack';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { type PlacementRenderProps } from '@post-office/browser--townsquare/goal-page-banners-placement';
import { useCallback } from 'react';

import { type JSX } from 'react/jsx-runtime';

export const SuccessMeasuresChangeboardingBanner = ({
	isGoalsOnlyUser,
	dismiss,
}: PlacementRenderProps): JSX.Element => {
	const { formatMessage } = useIntl();
	const { onClosed } = usePostOfficeUserInteractions();

	const dismissBanner = useCallback(() => {
		dismiss();
		void onClosed({
			interactionIdentifier: 'clickToDismissSuccessMeasuresModal',
		});
	}, [dismiss, onClosed]);

	return (
		<SectionMessage
			isDismissible
			onDismiss={dismissBanner}
			title={formatMessage(
				isGoalsOnlyUser ? messages.goalsChangeboardingTitle : messages.focusChangeboardingTitle,
			)}
			actions={[
				<SectionMessageAction href="https://support.atlassian.com/platform-experiences/docs/what-are-goal-types/">
					{formatMessage(messages.goalTypesLink)}
				</SectionMessageAction>,
			]}
		>
			<Stack space={'space.100'}>
				<Stack>
					{formatMessage(
						isGoalsOnlyUser ? messages.goalsIntroductionContent : messages.focusIntroductionContent,
					)}
				</Stack>
				<Stack>
					{formatMessage(isGoalsOnlyUser ? messages.goalsContent : messages.focusContent)}
				</Stack>
			</Stack>
		</SectionMessage>
	);
};
